import Button from "components/common/button/Button";
import If from "components/common/If";
import { uuid } from "config/app-constants";
import { DatalistDataSourceFilterDefinitionType, DatalistDataSourceFilterType, DatalistTableColumnType } from "types/datalist-types";
import DatalistFilterDataItem from "./DatalistFilterDataItem";

const colors = ['blue', 'red', 'green', 'yellow', 'orange', 'purple', 'pink']

type FilterType = DatalistDataSourceFilterType | DatalistDataSourceFilterDefinitionType | undefined;

type DatalistFilterDataPropsType<T, TFilter> = {
    value: FilterType
    name: string,
    columns: DatalistTableColumnType<T, TFilter, any>[],
    color?: 'red' | 'blue' | 'green' | 'yellow' | 'orange' | 'purple' | 'pink'
    onChange: (value: DatalistDataSourceFilterType | DatalistDataSourceFilterDefinitionType | undefined) => void
}

const DatalistFilterData = <T, TFilter>(props: DatalistFilterDataPropsType<T, TFilter>) => {
    if (!props.value) return <></>;
    const color = props.color || colors[0];
    const nextColor = colors.indexOf(color) + 1 < colors.length ? colors.indexOf(color) + 1 : 0;

    const filterNotEmpty = (array: []) => {
        let arrayFiltered = array.filter(function(x: any) {
            if (x === undefined) return false;
            if ('filters' in x) {
                if(x.filters.length === 0) return false;
                if(x.filters.length === 1 && x.filters[0] === undefined) return false;
            }
            return true;
        });

        arrayFiltered = arrayFiltered.map((x: any) => {
            if('filters' in x && x.filters.length === 1) {
                if('filters' in x.filters[0]) return x.filters[0];
            }
            return x;
        }) as any;

        return arrayFiltered;
    }

    const onChangeList = (value: DatalistDataSourceFilterType | DatalistDataSourceFilterDefinitionType | undefined, i: number) => {
        let filters: FilterType = { ...props.value } as FilterType;
        if (filters === undefined) return undefined;

        if ('filters' in filters) {
            filters.filters[i] = value as any;
            filters.filters = filterNotEmpty(filters.filters as any);
        }

        props.onChange(filters);
    }

    const add = (logic?: 'or' | 'and' | undefined) => {
        let data = {...props.value} as FilterType;

        if(data === undefined) {
            data = {
                id: uuid(),
                logic: logic || 'and',
                filters: [{
                    id: uuid()
                }]
            }
        } else if(logic && 'filters' in data) {
            data.filters.push({
                id: uuid(),
                logic: logic,
                filters: [{
                    id: uuid()
                }]
            });
        } else if('filters' in data!) {
            data.filters.push({
                id: uuid()   
            } as any);
        }
        
        props.onChange(data);
    }

    const onChangeLogic = (value: 'and' | 'or') => {
        let filters: FilterType = { ...props.value } as FilterType;
        if (filters === undefined || !('logic' in filters)) return;
        filters.logic = value;
        props.onChange(filters);
    }

    const getColor = (color: string) => {
        switch (color) {
            case 'blue':
                return 'border-l-2 pl-1 border-blue-400 hover:border-blue-600';
            case 'red':
                return 'border-l-2 pl-1 border-red-400 hover:border-red-600';
            case 'green':
                return 'border-l-2 pl-1 border-green-400 hover:border-green-600';
            case 'yellow':
                return 'border-l-2 pl-1 border-yellow-400 hover:border-yellow-600';
            case 'orange':
                return 'border-l-2 pl-1 border-orange-400 hover:border-orange-600';
            case 'purple':
                return 'border-l-2 pl-1 border-purple-400 hover:border-purple-600';
            case 'pink':
                return 'border-l-2 pl-1 border-pink-400 hover:border-pink-600';
        }
        return `border-l pl-1 border-${color}-400 hover:border-${color}-600`;
    }

    if ('filters' in props.value) {
        const currentColor = getColor(color);
        return <div className={currentColor}>
            <div className="">
                <div className="grid grid-cols-2 w-full">
                    <div className="w-full">
                        <Button theme={props.value.logic === 'or' ? 'link' : 'link primary'} title="add" onClick={() => onChangeLogic('and')}>
                            <span>And</span>
                        </Button>
                        <Button theme={props.value.logic === 'and' ? 'link' : 'link primary'} title="add" onClick={() => onChangeLogic('or')}>
                            <span>Or</span>
                        </Button>
                    </div>
                    <div className="text-right w-full">
                        <Button title="add" theme="link" onClick={() => add()}>
                            <i>Add</i>
                        </Button>
                        <If condition={props.value.filters?.length > 0}>
                            <Button title="add" theme="link" onClick={() => add('and')}>
                                <i>And</i>
                            </Button>
                            <Button title="add" theme="link" onClick={() => add('or')}>
                                <i>Or</i>
                            </Button>
                        </If>
                    </div>
                </div>
                <div>
                    {props.value.filters.map((f, i) => {
                        return <DatalistFilterData
                            value={f}
                            color={colors[nextColor] as any}
                            key={`${props.name}-${f.id}`}
                            columns={props.columns}
                            name={`${props.name}-${f.id}`}
                            onChange={j => onChangeList(j, i)}
                        />
                    })}
                </div>
                <div>
                </div>
            </div>
        </div>
    } else {
        return <DatalistFilterDataItem
            value={props.value as DatalistDataSourceFilterDefinitionType}
            columns={props.columns as any}
            name={props.name}
            onChange={props.onChange}
        />
    }
}

export default DatalistFilterData;
